module.exports = __webpack_public_path__ + "img/servicio-logistica.0f974f4c.jpg";